import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { toast } from "sonner";
import { useUser } from "#/hooks/use-user";
import ChangePasswordCard from "./ChangePasswordCard";
import { jsx as _jsx } from "react/jsx-runtime";
export function ChangePasswordView(t0) {
  const $ = _c(10);
  const {
    authClient,
    onSuccess,
    onBack
  } = t0;
  let t1;
  if ($[0] !== authClient) {
    t1 = {
      authClient
    };
    $[0] = authClient;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    updatePassword,
    isUpdating
  } = useUser(t1);
  const [statusMessage, setStatusMessage] = useState(null);
  let t2;
  if ($[2] !== onSuccess || $[3] !== updatePassword) {
    t2 = async (currentPassword, newPassword) => {
      const response = await updatePassword(currentPassword, newPassword);
      if (response.success) {
        toast.success(response.message);
        setStatusMessage({
          message: response.message,
          variant: "confirmation"
        });
        if (onSuccess) {
          onSuccess();
        }
      } else {
        setStatusMessage({
          message: response.message,
          variant: "error"
        });
      }
      return response;
    };
    $[2] = onSuccess;
    $[3] = updatePassword;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handlePasswordUpdate = t2;
  let t3;
  if ($[5] !== handlePasswordUpdate || $[6] !== isUpdating || $[7] !== onBack || $[8] !== statusMessage) {
    t3 = /*#__PURE__*/_jsx(ChangePasswordCard, {
      handlePasswordUpdate: handlePasswordUpdate,
      onBack: onBack,
      statusMessage: statusMessage,
      isLoading: isUpdating
    });
    $[5] = handlePasswordUpdate;
    $[6] = isUpdating;
    $[7] = onBack;
    $[8] = statusMessage;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}